export const REDUCER_NAME = "playerHistory";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_PLAYERHISTORY = `${REDUCER_NAME}/SET_PLAYERHISTORY`;
export const RESET_PLAYERHISTORY = `${REDUCER_NAME}/RESET_PLAYERHISTORY`;
